import React, { useState, useEffect, useRef } from 'react';
import styles from './Home.module.css';
import '../../App.module.css';
import WhatWeDoHero from '../WhatWeDoHero';
import Footer from '../Footer';
import SplitComponent from '../SplitComponent';
import SplitComponentReverse from '../SplitComponentReverse';
import SummaryComponent from '../SummaryComponent';

import { cardData, cardPolicy, cardPolitics } from './Data';

/*
  What We Do page.

  PRESERVES the original IntersectionObserver lateral-translation scroll
  animation on the three service cards. The wrappers, IDs, refs and class
  names are identical to the original Home.js setup, so the animation in
  Home.module.css continues to work exactly as before:

    .staggered-element { transform: translateX(-100vw); }
    .visible .staggered-element { transform: translateX(0); }
*/
function WhatWeDo() {
  const [visibleSections, setVisibleSections] = useState({});
  const sectionRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setVisibleSections((prev) => ({
            ...prev,
            [entry.target.id]: entry.isIntersecting,
          }));
        });
      },
      { threshold: 0, rootMargin: '0px 0px 0px 0px' }
    );

    const currentRefs = sectionRefs.current;
    currentRefs.forEach((ref) => { if (ref) observer.observe(ref); });

    return () => {
      currentRefs.forEach((ref) => { if (ref) observer.unobserve(ref); });
    };
  }, []);

  return (
    <div>
      <WhatWeDoHero />
      <SummaryComponent />

      <div className={styles['container']}>
        <div
          id="policy-section"
          ref={(el) => (sectionRefs.current[0] = el)}
          className={`${styles['animated-section']} ${visibleSections['policy-section'] ? styles['visible'] : ''}`}
        >
          <div className={styles['component-wrapper']}>
            <div className={styles['component-content']}>
              <div className={styles['staggered-element']} style={{ '--stagger-delay': '100ms' }}>
                <SplitComponent {...cardPolicy} />
              </div>
            </div>
          </div>
        </div>

        <div
          id="data-section"
          ref={(el) => (sectionRefs.current[1] = el)}
          className={`${styles['animated-section']} ${visibleSections['data-section'] ? styles['visible'] : ''}`}
        >
          <div className={styles['component-wrapper']}>
            <div className={styles['component-content']}>
              <div className={styles['staggered-element']} style={{ '--stagger-delay': '100ms' }}>
                <SplitComponentReverse {...cardData} />
              </div>
            </div>
          </div>
        </div>

        <div
          id="politics-section"
          ref={(el) => (sectionRefs.current[2] = el)}
          className={`${styles['animated-section']} ${visibleSections['politics-section'] ? styles['visible'] : ''}`}
        >
          <div className={styles['component-wrapper']}>
            <div className={styles['component-content']}>
              <div className={styles['staggered-element']} style={{ '--stagger-delay': '100ms' }}>
                <SplitComponent {...cardPolitics} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default WhatWeDo;
